// extracted by mini-css-extract-plugin
export var baseButton = "_q4-0";
export var controlsArrowKeys = "_q4-1";
export var controlsResetButton = "_q4-2";
export var lightGameButton = "_q4-4 _q4-0";
export var playAgainButton = "_q4-5 _q4-0";
export var startGameButton = "_q4-3 _q4-0";